import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {Grid, Card, CardActionArea, CardContent, Typography, CardMedia, Container} from '@material-ui/core';
import '../assets/styles/CreationSelection.css';
import Breadcrumb from './BreadcrumbsComponent';

const adOptions = {
  "Digital Ads": [
    { name: "Listing Ad", img: '/path/to/image1', route: '/listingad' },
    // Add more ad options for category1
  ],
  "Presentation": [
    { name: 'CMA Presentation', img: '/path/to/image3', route: '/cma-pres' },
    { name: 'Listing Presentation', img: '/path/to/image4', route: '/listing-pres' },
    { name: 'Buyer Presentation', img: '/path/to/image2', route: '/buyer-pres' },
    { name: 'Pre-Listing Presentation', img: '/path/to/image2', route: '/open-house-pres' },
    // Add more ad options for category2
  ],
  "Market Updates": [
    { name: 'Pre-construction E-mail', img: '/path/to/image5', route: '/option5' },
    { name: 'Pre-construction Design', img: '/path/to/image6', route: '/option6' },
    { name: 'Pre-construction Video', img: '/path/to/image7', route: '/option7' },
    { name: 'Market Trends Update', img: '/path/to/image7', route: '/option7' },
  ],
  "E-mail": [
    { name: 'Pre-Construction Project E-mail', img: '../src/assets/images/precon-email.png', route: '/smart-marketing/E-mail/precon' },
    { name: 'Market Updates E-mail', img: '../src/assets/images/market-update-email.png', route: '/market-updates' },
  ],
  "One-Pager": [
    { name: 'One-Pager 1', img: '/path/to/image10', route: '/option10' },
    { name: 'One-Pager 2', img: '/path/to/image11', route: '/option11' },
  ],
};

const CreationSelection = () => {
  const { category } = useParams();
  const history = useHistory();

  const handleOptionClick = (route) => {
    history.replace(route);
  };

  const options = adOptions[category] || []; // Retrieve ad options based on category

  return (

      <Container>
        <Grid container spacing={3}>
          <Breadcrumb />
        </Grid>

        <div className="preview-page">

      <Typography variant="h3" gutterBottom>Creation Page for {category}</Typography>

      <Grid container spacing={3}>
        {options.map((option, i) => (
          <Grid item key={i} xs={12} sm={6} md={4} lg={3}>
            <Card className="card">
              <CardActionArea onClick={() => handleOptionClick(option.route)}>
                <CardMedia
                  className="media"
                  image={option.img}
                  title={option.name}
                />
                <CardContent>
                  <Typography variant="h6">{option.name}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>

        </Container>
  );
}

export default CreationSelection;
